import { Button } from '@visikon/spine';
import { Tokens } from '@visikon/spine/src/styles/tokens';
import { NavigationIcon } from '../../images/icons';
import { useIsEmbedded } from '../../reducers/resourcesReducer';
import { useSelfServiceIsEditMode } from '../../screens/embeddedMessageScript/EmbeddedMessageScript';
import { IconWrapper } from './MoveButton';

type Props = {
  id?: string;
  currentIndex?: number;
  contentType: string;
  isTitle?: boolean;
};

export const EditButton = (p: Props) => {
  const onClick = () => {
    const action = p.isTitle ? 'title' : 'edit';
    window.parent.postMessage({ type: p.contentType, action: action, currentIndex: p.currentIndex }, '*');
  };

  const isEmbedded = useIsEmbedded();
  const isEditMode = useSelfServiceIsEditMode();

  if (!isEmbedded || !isEditMode) return null;

  return (
    <Button
      onClick={onClick}
      size={'small'}
      variant={'ghost'}
      style={{
        textTransform: 'none',
        background: 'rgba(0, 109, 179, 0.06)',
        fontWeight: Tokens.text.weight.bold,
        padding: '10px',
      }}
    >
      <IconWrapper>
        <NavigationIcon name="pencil" active={true} />
      </IconWrapper>
    </Button>
  );
};
